module.exports = __webpack_public_path__ + "img/404.b76e9c3a.png";